import { gql } from "@apollo/client";

const PLATFORM_PAGES = gql`
  query GetPlatformPages($platformPublicId: String!) {
    platformPages(platformPublicId: $platformPublicId) {
      id
      slug
      blocks
    }
  }
`;

export default PLATFORM_PAGES;
